// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { useSyncStore } from '@/store'

export function useOffline() {
  const { isOnline } = useSyncStore()
  return { isOnline, isOffline: !isOnline }
}
